class FraccionService {
    axios
    baseUrl

    constructor(axios, apiUrl) {
        this.axios = axios
        this.baseUrl = `${apiUrl}`
    }


    //////////////    UNIDAD    ///////////////   
    //Una sola unidad 
    getUnidada(id) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${id}`);
    }
    //catalogo unidad 
    getCatUnidad() {
        let self = this;
        return self.axios.get(`${self.baseUrl}CatUnidads`);
    }
      //btn unidad 
      getBtnUnidad() {
        let self = this;
        return self.axios.get(`${self.baseUrl}unidadbtn`);
    }
    // cat Icomno
    getIcon() {
        let self = this;
        return self.axios.get(`${self.baseUrl}CatIconoes`);
    }
    //Agregar Unidad
    addUnidad(objunidad) {
        let self = this;
        //   console.log(objunidad);
        return self.axios.post(`${self.baseUrl}CatUnidads`, objunidad);
    }
    
    //Actualizar Unidad 
    updateUnidad(objunidad) {
        let self = this;
        var id = objunidad.idUnidad;
        // console.log(id);
        return self.axios.put(`${self.baseUrl}CatUnidads/${id}`, objunidad);
    }

    //Eliminar Unidad
    removeUnidad(id) {
        let self = this;
        //  console.log(id);
        return self.axios.delete(`${self.baseUrl}borrarUnidad/${id}`);
    }
    ////////////////    Fracciones    /////////////////////////   
    // Especificas
    getCatFraccionE() {
        let self = this;
        return self.axios.get(`${self.baseUrl}especificas`);
    }
    // comunes
    getCatFraccionC() {
        let self = this;
        return self.axios.get(`${self.baseUrl}comunes`);
    }
    //catalogo Fraccion 
    getCatFraccion() {
        let self = this;
        return self.axios.get(`${self.baseUrl}catfraccion`);
    }
    getCatFraccionbtn() {
        let self = this;
        return self.axios.get(`${self.baseUrl}filtrobtn`);
    }

    getCatFraccionf(id) {
        let self = this;
        console.log("mua", id);
        return self.axios.get(`${self.baseUrl}catfraccion/${id}`);
    }
    getCatFraccionUsUn(dts) {
        let self = this;
        // console.log("pruebas de entrada a us unid ", dts);
        // console.log("pruebas de entrada a us unid ", dts.uidusuario);
        var id = dts.uidusuario;
        var idEmpleado=dts.vidempleado;
      
        return self.axios.get(`${self.baseUrl}Usuariofraccion${id}`);
    }
     ///  Usuario y sus Unidades
    getUsUniadp(id) {

        let self = this;
        console.log("desde service usuario",id);
      
        return self.axios.get(`${self.baseUrl}UsuarioUnidad/UnidadesUsuarios/${id}`);
    }
      //CAmbiar estaus de fraccion
      EstausFraccion(archivo) {
        let self = this;
        console.log("arreglo",archivo);
        // var Estatus= archivo.ESTATUS;
        var id = archivo.IdFraccion;
     
        console.log("desde service",id);
        return self.axios.put(`${self.baseUrl}estatusfraccion/${id}`, archivo);
    }



    ///Arvhovos en publicoTbl ////////////////////////////////////////////////////////////////////////////////
    tblArchivosPubli(id) {
        let self = this;
        //console.log("NO AMES",id);
        return self.axios.get(`${self.baseUrl}tbaf${id}`);
    }
    tblArchivosPunidad(id) {
        let self = this;
        console.log("NO Unidad",id);
        return self.axios.get(`${self.baseUrl}tbafu/${id}`);
    }
    
   // ttabla comn todos los archivos
    tblArchivos(id) {

        let self = this;
        console.log(id);
        return self.axios.get(`${self.baseUrl}tbarchivo${id}`);
    }
    ordernarArchivos(id_fraccion,id_archivo,newindex,oldindex) {
        let self = this;
        console.log("Hasta aqui");
        return self.axios.get(`${self.baseUrl}OrdenArchivo?id_fraccion=${id_fraccion}&id_archivo=${id_archivo}&newindex=${newindex}&oldindex=${oldindex}`);
    }
    tblArchivosUdependencia(id,idEmpleado) {
        let self = this;
        console.log("usuario service",idEmpleado)
        console.log(id);
        return self.axios.get(`${self.baseUrl}tbarchivoUsuario${id}/${idEmpleado}`);
    }
//////Tabla de Hipervinculos//////////////////////////////
    tblvinculos(id) {
        let self = this;
        console.log(id);
        return self.axios.get(`${self.baseUrl}tbvinculos${id}`);
    }
    //Agregar Fraccion
    addFraccion(objfraccion) {
        let self = this;
        console.log("Servise", objfraccion);
        return self.axios.post(`${self.baseUrl}CatFraccion`, objfraccion);
    }

    //Actualizar  
    updateFraccion(objfraccion) {
        let self = this;
        var id = objfraccion.idFraccion;
        console.log("desde service",objfraccion);
        return self.axios.put(`${self.baseUrl}CatFraccion/${id}`, objfraccion);
    }
    //Eliminar Unidad
    removeFraccion(id) {
        let self = this;
        //  console.log(id);
        return self.axios.delete(`${self.baseUrl}borrarUnidad/${id}`);
    }
    ddlTfraccion() {
        let self = this;
        return self.axios.get(`${self.baseUrl}CatFraccionTipoes`);
    }

    ////////////////       PERIODO     /////////////  
    getCatPeriodo() {
        let self = this;
        return self.axios.get(`${self.baseUrl}CatPeriodoes`);
    }
//filtrado de periodos por unidad y vigencia
getCatPeriodoFraccion(item){
    let self = this;
      console.log("item desd srevice",item);
      var id = item.idTipoPeriodo;
    return self.axios.get(`${self.baseUrl}CatPeriodoes/PeriodFraccion${id}`);
}
 

    addPeriodo(objperiodo) {
        let self = this;
        //   console.log(objunidad);
        return self.axios.post(`${self.baseUrl}CatPeriodoes`, objperiodo);
    }
    //Actualizar periodo
    updatePeriodo(objperiodo) {
        let self = this;
        var id = objperiodo.idPeriodo;
        console.log("desde service",objperiodo);
        return self.axios.put(`${self.baseUrl}CatPeriodoes/${id}`, objperiodo);
    }
    deletePeriodo(id){
        let self = this;
        return self.axios.delete(`${self.baseUrl}CatPeriodoes/${id}`);
       
       
    }
 
    getTipoPeriodo() {
        let self = this;
        return self.axios.get(`${self.baseUrl}CatTipoPeriodoes`);
    }


    ////////////////       Usuario     /////////////  /////////////////////////////////
    //catalogo TBL suarios  
    getCatUsuarios() {
        let self = this;
        return self.axios.get(`${self.baseUrl}VwUsuarioRol`);
        //return self.axios.get(`${self.baseUrl}catusuarios`);
    }
    //DDL ROL
    ddlRol() {
        let self = this;
        return self.axios.get(`${self.baseUrl}Rols`);
    }
    //Agregar Usuario
    addUserRol(objusuario) {
        var IdRol = 0;
        var Usuario = "";
        //var usuarioUnidad= objusuario.unidad;}
        console.log( "objunidada",objusuario);
        var usuarioUnidad = objusuario.unidad.map(item => {
            return { idUnidad: item };
        });
        console.log("Saliendo del Map", usuarioUnidad);
        let self = this;
        var adduser = { IdRol: objusuario.IdRol, NumeroEmpleado: objusuario.vidempleado, usuarioUnidad }
        console.log("Guardar usuario", adduser);
        return self.axios.post(`${self.baseUrl}Usuario`, adduser);
    }
    //Eliminar Usuario
    removeUser(id) {
        let self = this;
         console.log(id);
        return self.axios.delete(`${self.baseUrl}Usuario/${id}`);
    }
    //Actualizar Usuario
    updateUserRol(objusuario) {
        var IdRol = 0;
        var Usuario = "";
        console.log( "objunidada",objusuario);
        var id = objusuario.uidusuario;
        var usuarioUnidad = objusuario.unidad.map(item => {
            return { idUnidad: item, IdUsuario: objusuario.uidusuario };
        });
         console.log("Saliendo del Map",usuarioUnidad);
        let self = this;
        var adduser = { IdUsuario: objusuario.uidusuario, IdRol: objusuario.IdRol, NumeroEmpleado: objusuario.vidempleado, usuarioUnidad }
         console.log("Guardar usuario",adduser);  
        return self.axios.put(`${self.baseUrl}Usuario/${id}`, adduser);
    }
    //Usuario de inicio
    usInicio(id) {
        let self = this;
          console.log("Inicio",id);
        return self.axios.get(`${self.baseUrl}VwUsuarioRol/${id}`);
    }


    //////////  Descargar Archivo///////////////////
    archivodow(id) {

        let self = this;
        console.log(id);
        window.open(`${self.baseUrl}darchivo${id}`);
        //return self.axios.get(`${self.baseUrl}darchivo${id}`);
    }

    descTblApli() {

        let self = this;

        // window.open(`${self.baseUrl}darchivo${id}`);
        window.open(`${self.baseUrl}descTblApli`);
        //return self.axios.get(`${self.baseUrl}darchivo${id}`);
    }
    derogadas(id) {

        let self = this;
        console.log("desde service",id);
      
        return self.axios.get(`${self.baseUrl}api/Archivoes1/apiphp${id}`);
    }

    //Actualizar mostrar 
    mostrar(archivo) {
        let self = this;
        console.log("arreglo",archivo);
        // var Estatus= archivo.ESTATUS;
        var id = archivo.Id;
     
        console.log("desde service",id);
        return self.axios.put(`${self.baseUrl}estatus${id}`, archivo);
    }

    folio(llenapdf) {
        let self = this;
        // console.log("arreglofoolio",llenapdf);
        // var Estatus= archivo.ESTATUS;
        var id = llenapdf;
     
        console.log("desde service",id);
        return self.axios.get(`${self.baseUrl}Archivoes/${id}`);
    }


        addArchivo(farchivo) {
        let self = this;
        console.log("llega ",farchivo);
        var id = 88;
        var msj = "hola que hace";
 let rawData = {
            idFraccion: farchivo.idFraccion,
            idPerido: farchivo.idPeriodo,
          }
       
          console.log("file desde service",farchivo.files);
        let formData = new FormData();
      formData.append('file', farchivo.files);
               
        console.log("pprrprprpr", formData);
        return self.axios.post(`${self.baseUrl}darchivo/`,formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });

    }

    // Envio de mail
    mailc(item) {
      
        let self = this;
        console.log("email ",item);
        return self.axios.post(`${self.baseUrl}email`,item);

    }
    visitaGeneral(browserName) {
        let self = this;  
        return self.axios.post(`${self.baseUrl}VisitaGeneral?browser=${browserName}`);
    }

    visitaFraccion(id_fraccion,browserName) {
        let self = this;  
        return self.axios.post(`${self.baseUrl}VisitaFraccion?id_fraccion=${id_fraccion}&browser=${browserName}`);
    }

    EliminarArchivo(id) {
        let self = this;
        return self.axios.delete(`${self.baseUrl}EliminarArchivo?id=${id}`);
    }
}

export default FraccionService
